import {combineReducers} from "redux";
import dataStudioReducer from "src/control/reducers/notebooks/data_studio_reducers"

export default combineReducers({
    dataStudio: dataStudioReducer
});